// typescript
import { StateInterface } from 'client/Interfaces/StateInterface'
import { CompanySubscriptionStateInterface } from 'client/Interfaces/Subscription/ReduxStateInterfaces'
import { createSelector } from 'reselect'

// selectors
import { subscriptionCompanySelector } from './'

export const subscriptionCompanySubscriptionSelector = createSelector<
  StateInterface,
  StateInterface['subscriptionManagement']['companySubscription'],
  StateInterface['subscriptionManagement']['companySubscription']['subscription']
>(
  subscriptionCompanySelector,
  (companySubscription: CompanySubscriptionStateInterface) => companySubscription && companySubscription.subscription,
)
